module.exports = __webpack_public_path__ + "img/foot-play.7390e830.png";